if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

// === 画像ギャラリー：矢印ナビゲーション＋マウスドラッグ（修正版）===
(function () {
  function initGalleryNav() {
    const gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    const thumbnailsContainer = gallery.querySelector('[id^="GalleryThumbnails"]');
    if (!thumbnailsContainer) return;

    // サムネイルのラッパーを取得
    const thumbnailsWrapper = thumbnailsContainer.parentElement || thumbnailsContainer;

    // 既存の矢印があれば削除（重複防止）
    gallery.querySelectorAll('.custom-gallery-arrow').forEach(el => el.remove());

    // --- 矢印ボタン作成 ---
    const prevBtn = document.createElement('button');
    prevBtn.className = 'custom-gallery-arrow custom-gallery-arrow--prev';
    prevBtn.innerHTML = '‹';
    prevBtn.setAttribute('aria-label', '前の画像');

    const nextBtn = document.createElement('button');
    nextBtn.className = 'custom-gallery-arrow custom-gallery-arrow--next';
    nextBtn.innerHTML = '›';
    nextBtn.setAttribute('aria-label', '次の画像');

    // サムネイルエリアの親に relative を付けて矢印を配置
    thumbnailsWrapper.style.position = 'relative';
    thumbnailsWrapper.appendChild(prevBtn);
    thumbnailsWrapper.appendChild(nextBtn);

    // --- サムネイルを切り替える関数（ズームなし）---
    function switchMedia(direction) {
      const thumbnails = Array.from(
        thumbnailsContainer.querySelectorAll('[data-target]')
      );
      if (thumbnails.length === 0) return;

      const currentBtn = thumbnailsContainer.querySelector('button[aria-current="true"]');
      const currentThumb = currentBtn?.closest('[data-target]');
      const currentIdx = currentThumb ? thumbnails.indexOf(currentThumb) : 0;

      let nextIdx;
      if (direction === 'next') {
        nextIdx = currentIdx + 1 >= thumbnails.length ? 0 : currentIdx + 1;
      } else {
        nextIdx = currentIdx - 1 < 0 ? thumbnails.length - 1 : currentIdx - 1;
      }

      const targetId = thumbnails[nextIdx].dataset.target;
      // media-gallery の setActiveMedia を直接呼ぶ（ズームなし）
      gallery.setActiveMedia(targetId, false);
    }

    prevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      switchMedia('prev');
    });

    nextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      switchMedia('next');
    });

    // --- メインビューアーでマウスドラッグ切り替え ---
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (viewer) {
      let startX = 0;
      let isDragging = false;

      viewer.addEventListener('mousedown', (e) => {
        startX = e.clientX;
        isDragging = true;
      });

      viewer.addEventListener('mouseup', (e) => {
        if (!isDragging) return;
        isDragging = false;
        const diff = startX - e.clientX;
        if (Math.abs(diff) < 50) return;
        switchMedia(diff > 0 ? 'next' : 'prev');
      });

      viewer.addEventListener('mouseleave', () => { isDragging = false; });

      // ドラッグ中のテキスト選択を防ぐ
      viewer.addEventListener('dragstart', (e) => e.preventDefault());
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryNav);
  } else {
    initGalleryNav();
  }
})();
